export default "__VITE_ASSET__4aac657c__"